import { CustomerQueryParams, OrderQueryParams, QueryParamDataType, WorkspaceSettingsViews } from '../constants';

const OrdersPageQueryParams = {
  [CustomerQueryParams.CUSTOMER_PROFILE]: {
    required: false,
    type: QueryParamDataType.STRING,
  },
  [OrderQueryParams.PAGE]: {
    required: false,
    type: QueryParamDataType.NUMBER,
  },
  [OrderQueryParams.ORDER]: {
    required: false,
    type: QueryParamDataType.UUID,
  },
  [OrderQueryParams.SETTINGS]: {
    required: false,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: WorkspaceSettingsViews,
  },
};

export default OrdersPageQueryParams;
